const Keychain = {
  resetGenericPassword: () => {},
};

export default Keychain;
